import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';

import './BackButton.scss';

class BackButton extends Component {
  static contextTypes = {
    router: PropTypes.object
  };

  handleClick = () => {
    if (this.props.history.action === 'PUSH') {
      return this.context.router.history.goBack();
    }
    return this.context.router.history.push(this.props.whereBack || '/');
  };

  render() {
    return (
      <div className="row col-md-12 divOutline">
        <div className="btn-outline" onClick={() => this.handleClick()}>
          <i className={'fa fa-chevron-left btn-text'} />
          Zurück zu Geschenken
        </div>
      </div>
    );
  }
}

export default withRouter(BackButton);



// WEBPACK FOOTER //
// ./src/Containers/HomeElements/BackButton.js